module.exports = [{"color":"#249CE6","value":"249CE6"},{"color":"#F7B32A","value":"F7B32A"},{"color":"#5CBC8D","value":"5CBC8D"},{"color":"#9BCC49","value":"9BCC49"},{"color":"#F06834","value":"F06834"},{"color":"#8B562B","value":"8B562B"},{"color":"#660DB3","value":"660DB3"},{"color":"#CC2035","value":"CC2035"}]


//////////////////
// WEBPACK FOOTER
// ./src/config/theme.json
// module id = NbFj
// module chunks = 0